import { render, staticRenderFns } from "./BookMarks.vue?vue&type=template&id=61a68aee"
import script from "./BookMarks.vue?vue&type=script&lang=js"
export * from "./BookMarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports